module.exports = __webpack_public_path__ + "static/SyedHamzaResume-cd765fd0560e2e233276125c6716fd6d.pdf";